import type { Session } from '@supabase/supabase-js';
import { z } from 'zod';

import { apiFetch } from '@/lib/api';

// Client-side contract for GET /api/v1/admin/system. Kept in lockstep with the
// API's response schema (apps/api/src/routes/admin.ts); Zod-parsed on arrival
// so any drift between client and API surfaces as a loud error, not a silently
// mis-rendered panel.
export const SystemInfoSchema = z.object({
  env: z.enum(['development', 'production', 'test']),
  commit: z.string(),
  ai: z.object({
    provider: z.enum(['gemini', 'openai', 'claude']),
    model: z.string(),
  }),
  db: z.enum(['ok', 'down']),
});

export type SystemInfo = z.infer<typeof SystemInfoSchema>;

export const fetchSystemInfo = (session: Session, signal?: AbortSignal): Promise<SystemInfo> =>
  apiFetch('/api/v1/admin/system', {
    session,
    schema: SystemInfoSchema,
    ...(signal ? { signal } : {}),
  });
